import React from 'react';


export const NotFound = () => {
  return (
    <div className="bg--gray">
      <div className="layout-container pb64">
        <div className="layout-single error__wrap">
          <h2 className="error-title">404</h2>
          <h3 className="error-title__sub">ページがみつかりませんでした。</h3>
          <div className="error__text">お探しのページは、URLが変更または削除されている可能性があります。<br />お手数ですが、以下のリンクよりトップページに遷移してください。</div>
          <a href="/" className="button-base--line button-w288 error__button">トップページへ</a>
        </div>
      </div>
    </div>
  );
};
